import {Margin} from 'ui-library/charting/internals/VisxUtilityTypes';

import getTickLabelWidths from './getTickLabelWidths';
import {VisxAxisConfig} from './getVisxAxisConfig';
import {AXIS_LABEL_TO_TICK_LABEL, LABEL_FONT_SIZE, TICK_LABEL_TO_AXIS} from './Theme';

export interface GetYTickLabelMarginInput {
  currentMargins: Margin;
  yAxisConfig: VisxAxisConfig;
}

/**
 * Compute chart margins based on y-axis tick labels.
 *
 * If the longest tick label would not fit in currentMargins, returns an updated set of margins with a left
 * margin that would fit that label.
 */
export default function getYTickLabelMargins({
  currentMargins,
  yAxisConfig,
}: GetYTickLabelMarginInput): Margin {
  const tickLabelWidths = getTickLabelWidths(yAxisConfig);
  const maxTickLabelWidth = Math.max(...tickLabelWidths);
  const leftMargin = Math.max(
    TICK_LABEL_TO_AXIS +
      maxTickLabelWidth +
      (yAxisConfig.label === undefined ? 0 : AXIS_LABEL_TO_TICK_LABEL + LABEL_FONT_SIZE),
    currentMargins.left
  );
  return {...currentMargins, left: leftMargin};
}
